import creditEngineRepository, { CreditEngineRepository } from './CreditEngineRepository'

const resource = '/mandate';
export default {
  getMandateConfiguration(mandateConfigRequest) {

    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/configuration`, mandateConfigRequest);
  }
}